export default "__VITE_ASSET__08b81f10__"